import { AnyDate } from "ui/common/hooks/useFormatDate/useFormatDate.types";

export default function isValidDate(date: AnyDate) {
    try {
        return new Date(date).toString() !== "Invalid Date";
    } catch (e) {
        // eslint-disable-next-line
        console.error("Is invalid date");
        return false;
    }
}
